import React, { Component } from 'react';
import VehicleForm from './VehicleForm';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { updateTitle } from '../SectionTitle/actions';

const mapStateToProps = (state) => {
    //
    return {
        state: state
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateTitle: (titleObj) => dispatch(updateTitle(titleObj))
    }
}

class VehicleContainer extends Component {
    constructor(props) {
        super(props);
        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        //alert('test');
        this.props.updateTitle({
            title: '<h1>Vehicle</h1>',
            subTitle: `<div><span class="estimateMonths">$${this.props.state.userConfirmation.estimate}</span> for 6 months</div>`,
            image: '<i class="fa fa-car" aria-hidden="true"></i>'
        });
    }
    prevPage(){
        const {history} =this.props;
        history.goBack();
    }

    nextPage(id, vehicles) {
        //window.scrollTo(0, 0);
        console.log(vehicles);
        const length = vehicles.length - 1;
        id = ++id;
        console.log(length);
        console.log(id);
        const { history } = this.props;

        if (id <= length) {
            window.scrollTo(0, 0);
            //return `/vehicle/${id}`;
            history.push(`/vehicle/${id}`);

        }
        else {
            history.push(`/history`);
        }

    }

    getDriverData(vehicles, index) {
        return vehicles[index]
    }

    render() {
        if (this.props.state.ReviewReducer.reviewData === undefined) {
            return (
                <Redirect to='/' />
            )
        }
        else {
            //const { props } = this;
            const { id } = this.props.match.params;
            const { vehicles } = this.props.state.ReviewReducer.reviewData;
            const currentVehicle = this.getDriverData(vehicles, id);
            const currentState = this.props.state;
            //const nextPage = this.nextPage(id, vehicles);
            //const nextPage = '/driver'
            return (
                <div>
                    <VehicleForm
                        currentState = {currentState}
                        onPrevPage={this.prevPage}
                        onNextPage={() => this.nextPage(id, vehicles)}
                        currentVehicle={currentVehicle} />
                </div>
            );
        }

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleContainer);


// WEBPACK FOOTER //
// ./src/Vehicle/index.js